
import { mapGetters, mapMutations } from 'vuex'
export default {
  props: {
    isShowHeader: { default: true, type: Boolean },
    title: {},
  },
  data() {
    return {
      drawer: false,
      direction: 'rtl',
    }
  },
  methods: {
    ...mapMutations(['SET_DRAWER']),
  },
  computed: {
    ...mapGetters(['GET_DRAWER']),
  },
}
